import { connect } from 'react-redux';
import {
  refreshUser,
  showAlert,
  changeUserProfilePic
} from 'state/actions/actions';
import withLocalLoader from 'components/HOCs/withLocalLoader';
import MyProfile from 'tailwind-components/MyProfile/MyProfile';
import SunshineMyProfile from '../../views/AgentInfo/AgentInfoView';

import { getCompany } from 'helpers/getCompanyVariables';

const isOneill = getCompany() === 'oneill';

const mapStateToProps = ({ user }) => ({
  zohoData: user.zohoData
});

export default connect(mapStateToProps, {
  refreshUser,
  showAlert,
  changeUserProfilePic
})(
  withLocalLoader(
    isOneill ? MyProfile : SunshineMyProfile,
    true,
    'My Profile',
    'My Profile'
  )
);
